import React from "react";
import { Container, Row, Col } from "reactstrap";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <React.Fragment>
      <div
        className="footer my-1 pb-0 mx-2 rounded-4 ff-sora d-flex align-items-center text-center justify-content-center"
        style={{ height: "46px", background: "#44444c", color: "white" }}
      >
        <p className="font-size-16 ff-sora fw-normal text-center mx-0 ">
          © Copyrights {currentYear} - All Rights Reserved.
        </p>
      </div>
    </React.Fragment>
  );
};

export default Footer;
